import anime from 'animejs'
import {
  createAnimation
} from '../utils/createAnimation'
import {
  characterWalk
} from '../utils/characterWalk'
import {
  createRotateAnimation
} from '../utils/createRotateAnimation'

// Reece animations
const reeceAnimations = () => {

  return {

    slideIn(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#reece",
            right: ['-20%', '20%'],
            duration: 2000,
            easing: 'linear',
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },

    walkInPlace(options) {
      return createAnimation((tl, options) => {

        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        options.right = options.right || ['20%', '45%']

        tl
          .add({
            targets: '#reece',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip reece conditionally
            right: {
              value: options.right,
              duration: 10000 // options.duration / 3
            }, // gradually move closer to center of scene
            translateY: characterWalk(options.duration),
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })

      }, options, this)()
    },

    rotate(options) {
      return createAnimation(createRotateAnimation('#reece'), options, this)()
    },

    headRotate(options) {
      // rotated: true rotates head, rotated: false resets head
      return createAnimation((tl, options) => {
        options.flipped = options.flipped || false
        tl
          .add({
            targets: "#reece_head",
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1,
              begin: options.begin,
              complete: options.complete
            },
          })
      }, options, this)()
    },

    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#reece_right_arm_hand',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin
          })
          .add({
            targets: '#reece_right_arm',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)() // make sure to invoke method!
    },

    raiseRightArm(options) {
      return createAnimation((tl, options) => { // wrap in callback for delay

        tl.add({ // begin callback has its own seperate timeline hook
          targets: '#null',
          begin: options.begin,
          duration: 1
        })

        if (options.wave || options.full) { // raise full arm if waving or full is specified
          tl
            .add({
              targets: '#reece_right_arm',
              rotate: '30deg',
              easing: 'linear',
              duration: 350
            })
        }

        tl // raise forearm
          .add({
            targets: '#reece_right_arm_hand',
            rotate: '95deg',
            easing: 'linear',
            duration: 498, // account for 1ms begin and complete callbacks
          })

        if (options.wave) { // wave animation if specified
          tl
            .add({
              targets: '#reece_right_arm_hand',
              rotate: '105deg',
              easing: 'linear',
              duration: 300,
              delay: 300,
            })
            .add({
              targets: '#reece_right_arm_hand',
              rotate: '95deg',
              easing: 'linear',
              duration: 300,
            })
            .add({
              targets: '#reece_right_arm_hand',
              rotate: '105deg',
              easing: 'linear',
              duration: 300,
            })
            .add({
              targets: '#reece_right_arm_hand',
              rotate: '95deg',
              easing: 'linear',
              duration: 300,
            })
        }

        tl.add({ // complete callback has its own seperate timeline hook
          targets: '#null',
          complete: options.complete,
          duration: 1
        })
      }, options, this)()
    },

    raiseLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#reece_left_arm_hand',
            rotate: '90deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },

    lowerLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#reece_left_arm_hand',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    }
  }
}

export {
  reeceAnimations
}



// WEBPACK FOOTER //
// ./src/assets/js/characters/reeceAnimations.js